/* 0511ER v8 — ui.js: Navigation, Warenkorb-Zähler, Scroll-Reveal */
(function () {
  'use strict';

  /* Mobile Navigation: startet direkt unter der Kopfzeile, schließt mit Escape und bei Linkklick */
  var burger = document.getElementById('nav-burger');
  var mobile = document.getElementById('nav-mobile');
  var header = document.querySelector('.site-header');
  function setMenu(open) {
    if (!burger || !mobile) return;
    if (open && header) mobile.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
    mobile.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && mobile) {
    burger.addEventListener('click', function () { setMenu(!mobile.classList.contains('open')); });
    mobile.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    window.matchMedia('(min-width: 900px)').addEventListener('change', function (m) { if (m.matches) setMenu(false); });
  }

  /* Warenkorb-Zähler: Badge ausblenden, wenn 0 (auch wenn stufe3.js die Zahl setzt) */
  function badge(el) { el.setAttribute('data-leer', String(parseInt(el.textContent, 10) === 0)); }
  var zaehler = document.querySelectorAll('[data-cart-count]');
  zaehler.forEach(function (el) {
    badge(el);
    new MutationObserver(function () { badge(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { zaehler.forEach(function (el) { el.textContent = cart.item_count; }); })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', updateCartCount);

  /* Scroll-Reveal: 40 ms gestaffelt, höchstens 4 Schritte, startet vor dem Sichtbereich */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var group = el.closest('[data-reveal-group]');
        var delay = 0;
        if (group) delay = Math.min(Math.max(0, Array.prototype.indexOf.call(group.querySelectorAll('.reveal'), el)), 4) * 40;
        setTimeout(function () { el.classList.add('in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px 10% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
  /* Sortierung: bei Auswahl sofort laden. Aktiven Chip mobil ins Bild holen. */
  document.querySelectorAll('[data-sortierung] select').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });
  var chip = document.querySelector('.chip--aktiv');
  if (chip && chip.parentElement.scrollWidth > chip.parentElement.clientWidth) {
    chip.parentElement.scrollLeft = chip.offsetLeft - 16;
  }
})();
